import { makeStyles } from "@mui/styles";

// Gemeinsame Styles fuer die Objekt-/Bauteil-Listen-Views (bisher wortidentisch in
// mehreren Dateien dupliziert: ObjectFields, BimetaData, BimetaProfiles, BimProfiles,
// BimProjects, Datacomponents, WuDbData, FileMapping).
// Hinweis: root/lightButton/darkButton wurden in denselben Dateien ebenfalls dupliziert
// definiert, aber nirgends tatsaechlich als className verwendet - als totes Styling
// nicht mit uebernommen.
export const useSharedListStyles = makeStyles({
    katalogView: {
        width: "100%",
        height: "100%",
        float: "left",
    },
    btListe: {
        width: "100%",
        maxHeight: "100vh",
        float: "left",
    },
    table: {
        minWidth: 700,
    },
});
